<div class="flex gap-1.5">
  @if (page() !== 1) {
  <!-- <button class="join-item btn btn-ghost rounded-md" (click)="page.set(1)">
      <app-icon name="ri:skip-left-line" class="!size-4" />
    </button> -->
  <button class="join-item btn btn-ghost rounded-md" (click)="page.set(page() - 1)">
    <app-icon name="mdi:chevron-left" class="!size-4" />
  </button>
  } @for (_page of pages(); track _page) {
  <input
    class="join-item btn rounded-md font-normal"
    type="radio"
    [name]="uid"
    [checked]="_page === page()"
    [class.btn-primary]="page() === _page"
    [class.btn-ghost]="page() !== _page"
    [ariaLabel]="_page"
    (change)="handleChange(_page)" />
  } @if (page() !== pageInfo().totalPages && pageInfo().totalItems !== 0) {
  <button class="join-item btn btn-ghost rounded-md" (click)="page.set(page() + 1)">
    <app-icon class="text-gray-700 !size-4" name="mdi:chevron-right" />
  </button>
  <!-- <button class="join-item btn btn-ghost rounded-md">
      <app-icon
        class="text-gray-700 !size-4"
        name="ri:skip-right-line"
        (click)="page.set(pageInfo().totalPages || 0)" />
    </button> -->
  }
</div>
